const ENV = {
    REST: {

        URL_MAIN2: 'api/public/',
        URL_MAIN3: 'https://dideco-respaldo.herokuapp.com/api/apisd/public/',
       // URL_MAIN4: 'https://dideco-rest.herokuapp.com/',
        URL_MAIN4: 'https://dideco-respaldo.herokuapp.com/api/apisgd/public/',
      
        URL_MAIN5: 'https://a.herokuapp.com/',
      
        URL_MAINARC: 'https://a.herokuapp.com/',
        URL_MAINARCEP: 'https://a.herokuapp.com/',
      
       // URL_MAINARC: 'https://dideco-refrendos.herokuapp.com/',
        URL_MAINREF: 'https://a.herokuapp.com/',
        
        URL_MAINARC2: 'https://a.herokuapp.com/',
        URL_MAINRESP: 'https://a.herokuapp.com/',

 

   /*
  URL_MAIN3: 'https://dideco-respaldo.herokuapp.com/api/NAD/apisgd/public/',
  // URL_MAIN4: 'https://dideco-rest.herokuapp.com/',
   URL_MAIN4: 'https://dideco-respaldo.herokuapp.com/api/NAD/apisgd/public/',
 
   URL_MAIN5: 'https://dideco-respaldo.herokuapp.com/api/NAD/apisgd/public/',
 
   URL_MAINARC: 'https://dideco-respaldo.herokuapp.com/api/NAD/apisgd/public/',
   URL_MAINARCEP: 'https://dideco-respaldo.herokuapp.com/api/NAD/apisgd/public/',
 
  // URL_MAINARC: 'https://dideco-refrendos.herokuapp.com/',
   URL_MAINREF: 'https://dideco-respaldo.herokuapp.com/api/NAD/apisgd/public/',
   
   URL_MAINARC2: 'https://dideco-respaldo.herokuapp.com/api/NAD/apisgd/public/',
   URL_MAINRESP: 'https://dideco-respaldo.herokuapp.com/api/NAD/apisgd/public/',
 */
//URL_MAIN: 'http://localhost:3001',
        MODULES:{
           //Estrutura ejemplo despues modular 
            SECURITY:{
                NAME_ROUTE: '/api/security',
                ACTIONS:{
                    GET_SECURITY_LOGIN: '/getlogin/:email/:password',
                    GET_SECURITY_USER_PERMISSIONS: '/getpermissions/:idUser/:tipoPagina',
                    PUT_SECURITY_PROFILE_PHOTO: '/putsecurityprofilephoto/:IdPersona'
                }
            },
        

            
            
           
        }
    },
 
};

const getModulePath = (module) => {
    return (action) => ENV.REST.URL_MAIN
        + ENV.REST.MODULES[module].NAME_ROUTE
        + ENV.REST.MODULES[module].ACTIONS[action];
};


export {getModulePath, ENV};